enum DeploymentTypes {
  SET_ALL_DEPLOYMENTS = '[DEPLOYMENT] SET_ALL',
  SELECT_DEPLOYMENT = '[DEPLOYMENT] SELECT',
  UPDATE_RESOURCE_STATE = '[DEPLOYMENT] UPDATE_RESOURCE_STATE',
  ADD_PENDING = '[DEPLOYMENT] ADD_PENDING',
  REMOVE_PENDING = '[DEPLOYMENT] REMOVE_PENDING',
}

export default DeploymentTypes;
